import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  obterTudo,
  recalcular,
  obterConfig,
  atualizarConfig,
} from '../../../services/dashboardPreditivoService';

// O backend retorna um objeto cujo formato é:
//   { tipo: { payload: <valor calculado>, calculated_at: 'iso' }, ... }
// Para cada tipo, payload pode ser objeto (kpis_mes) ou array (listas).

const initialState = {
  dados: {},          // { [tipo]: { payload, calculated_at } }
  config: null,
  loading: false,
  loadingConfig: false,
  recalculando: false,
  error: null,
};

export const fetchDashboard = createAsyncThunk(
  'dashboardPreditivo/fetch',
  async () => obterTudo(),
);

export const recalcularThunk = createAsyncThunk(
  'dashboardPreditivo/recalcular',
  async (_, { dispatch }) => {
    const resp = await recalcular();
    dispatch(fetchDashboard());
    return resp;
  },
);

export const fetchConfig = createAsyncThunk(
  'dashboardPreditivo/fetchConfig',
  async () => obterConfig(),
);

export const atualizarConfigThunk = createAsyncThunk(
  'dashboardPreditivo/atualizarConfig',
  async (payload, { dispatch }) => {
    const resp = await atualizarConfig(payload);
    dispatch(fetchConfig());
    return resp;
  },
);

const DashboardPreditivoSlice = createSlice({
  name: 'dashboardPreditivo',
  initialState,
  reducers: {
    limparErro: (s) => { s.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchDashboard.fulfilled, (s, a) => {
        s.loading = false;
        s.dados = a.payload || {};
      })
      .addCase(fetchDashboard.rejected, (s, a) => {
        s.loading = false;
        s.error = a.error?.message || 'Falha ao carregar dashboard';
      })

      .addCase(recalcularThunk.pending, (s) => { s.recalculando = true; })
      .addCase(recalcularThunk.fulfilled, (s) => { s.recalculando = false; })
      .addCase(recalcularThunk.rejected, (s, a) => {
        s.recalculando = false;
        s.error = a.error?.message || 'Falha ao recalcular';
      })

      .addCase(fetchConfig.pending, (s) => { s.loadingConfig = true; })
      .addCase(fetchConfig.fulfilled, (s, a) => {
        s.loadingConfig = false;
        s.config = a.payload;
      })
      .addCase(fetchConfig.rejected, (s, a) => {
        s.loadingConfig = false;
        s.error = a.error?.message || 'Falha ao carregar configuração';
      });
  },
});

export const { limparErro } = DashboardPreditivoSlice.actions;
export default DashboardPreditivoSlice.reducer;
